import styled from "styled-components";

export default styled.div`
    cursor: pointer;
    user-select: none;
    opacity: 0.7;
    font-size: 14px;
`;
